/**
 * Not Found Page (404)
 */

import {
  Box,
  Button,
  Container,
  Heading,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { Routes } from "../routes";

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Box
      minH="100vh"
      bg="bg"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Container maxW="sm">
        <VStack gap="6" textAlign="center">
          <Text fontSize="6xl">🔍</Text>
          <Heading as="h1" size="2xl" color="fg">
            404
          </Heading>
          <Text fontSize="xl" color="fg.muted">
            Page Not Found
          </Text>
          <Text color="fg.muted">
            The page you're looking for doesn't exist or has been moved.
          </Text>
          <Button
            colorPalette="blue"
            size="lg"
            onClick={() => navigate(Routes.LANDING)}
          >
            Go to Home
          </Button>
        </VStack>
      </Container>
    </Box>
  );
}
